import { api } from '../../services/api';
import {
  GET_HEALTH_INSURANCE_SUCCESS,
  GET_HEALTH_INSURANCE_FAILURE,
  SAVE_HEALTH_INSURANCE,
  SET_LOADING
} from '../reducers/types';

export const gethealthInsurance = (id) => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADING });
    const response = await api.get(`/medicos/${id}/obra_sociales`);
    dispatch({ type: GET_HEALTH_INSURANCE_SUCCESS, payload: response.data.obras_sociales });
  } catch (error) {
    dispatch({ type: GET_HEALTH_INSURANCE_FAILURE, payload: error });
  }
};

export const savehealthInsurance = (healthInsurance) => async (dispatch) => {
  dispatch({ type: SAVE_HEALTH_INSURANCE, payload: healthInsurance });
};
